import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import Img from 'gatsby-image';

import Heading from './Heading';
import { Para } from './elements';

const Container = styled.div`
  padding: 2.5rem 0rem;
  h2 {
    margin: 1rem 0 2.25rem;
  }
  img {
    object-fit: cover;
    border-radius: 8px;
  }
  button {
    margin-bottom: 1rem;
  }
  .left-column {
    display: grid;
  }
  .bottom-imgs {
    align-self: flex-end;
  }
  .left-img {
    height: 540px;
  }
  .right-imgs {
    height: 200px;
  }
`;

const Ingredients = ({ data }) => (
  <Container className="container">
    <section className="section">
      <div className="columns">
        <div className="column is-half">
          <Img
            fluid={data.ingredient.image[0].asset.fluid}
            className="left-img"
            alt={data.ingredient.title}
          />
        </div>
        <div className="column is-half left-column">
          <div>
            <Heading>{data.ingredient.title}</Heading>
            <Para>{data.ingredient.subtitle}</Para>
            <Link
              to="/shop"
              className="is-uppercase button is-medium is-secondary"
            >
              shop now
            </Link>
          </div>
          <div className="columns bottom-imgs">
            <div className="column">
              <Img
                fluid={data.ingredient.image[1].asset.fluid}
                className="right-img"
                alt={data.ingredient.title}
              />
            </div>
            <div className="column">
              <Img
                fluid={data.ingredient.image[2].asset.fluid}
                className="right-img"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  </Container>
);

export default Ingredients;
